export class ExternalMAMImportRequest {
  constructor(
    public id: string,
    public connectionId: string,
    public videoIds: Array<string> = [],
  ) {}
}
